import API from '@/models/API';

export default class NewCampaign {
  constructor(item = {}) {
    this.category = item.category || '';
    this.campaign_type_system = item.campaign_type_system || '';
    this.campaign_type_id = item.campaign_type_id || '';
    this.campaign_type_id_options = item.campaign_type_id_options || {};

    this.campaign_condition_id = item.campaign_condition_id || '';
    this.campaign_condition_id_options = item.campaign_condition_id_options || {};

    this.campaign_client_characteristic_id = item.campaign_client_characteristic_id || null;
    this.campaign_client_characteristic_id_options =
      item.campaign_client_characteristic_id_options || {};

    this.system_notification_ids = item.system_notification_ids || [];
    this.notifier_type = item.notifier_type || 'priority';
    this.override_user_notification_settings = item.override_user_notification_settings || false;

    this.campaign_reward =
      item.campaign_reward ||
      {
        // gift_id: null,
        // reward_points: "",
        // multi_points_ratio: null,
        // coupon_claim_valid_days: null,
        // notification: {
        //     en: '',
        //     el: '',
        //     it: ''
        // },
      };

    ((this.invoicing_settings =
      item.invoicing_settings ||
      {
        // company: false,
        // store: false,
        // both: false,
        // both_percentages: {
        //     company: 0
        // },
      }),
      (this.title = item.title || ''));
    //  {
    //     en: "",
    //     el: "",
    //     it: ""
    // }
  }

  static getCampaignSystemNotifications = () =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-system-notifications`
    );

  static getCampaignTypes = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/campaign-types`);

  static getStores = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/stores${query}`);

  static getAllRewards = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/rewards${query}`);

  static getTransactionTypes = () => API.get(`/common/campaigns/transaction-types`);

  static getProducts = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/products${query}`);

  static getCampaigns = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns${query}`);

  static getCoupons = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/customer-rewards`);

  static getClientCharacteristics = (typeId) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-client-characteristics?campaign-type-id=${typeId}`
    );

  static create = (item) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/campaigns/`, item);

  static uploadImage = (image, type, b64 = false) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/campaigns/images/${type}${b64 ? '?encode=b64' : ''}`,
      image
    );

  static uploadFile = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/campaigns/csv`, file);
  static uploadTestFile = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/campaigns/test-notifier/images`, file);
  static sendTestMessage = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/campaigns/test-notifier`, body);
  static getConditions = (typeId) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/campaigns/campaign-conditions?campaign-type-id=${typeId}`
    );
  static getNotificationVariables = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/campaigns/notification-variables`);

  static getLoyalties = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/loyalties${query}`);

  static sendRewardSmsTest = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/campaigns/reward-sms-test-send`, body);
}
